import type { FC, ReactNode } from "react";
import type { LinkItem } from "src/http/api-types";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import {
  StyledSubHeading,
  StyledTeamCardWithHover,
  StyledTeamGroupingSection,
  StyledTeamsGrid,
} from "../styled-components";

interface Props {
  name?: ReactNode;
  teams: LinkItem[];
}

/**
 * Represents a Grouping of Teams, Whether it be Conference, League, Division, etc.
 * Contains a header title for the grouping & a list of teams
 */
export const TeamGroupingSection: FC<Props> = ({ name, teams }) => {
  const storePageEvent = useStorePageEvent();
  return (
    <StyledTeamGroupingSection>
      <StyledSubHeading>{name}</StyledSubHeading>
      <StyledTeamsGrid>
        {teams.map((team) => (
          <li key={team.id}>
            <StyledTeamCardWithHover
              key={team.id}
              {...team}
              onClick={() => {
                storePageEvent(PE_TYPE.CLICK, PE_KEYS.CATEGORY_GROUPING_SPORTS_LINK_CLICK, String(team.id));
              }}
            />
          </li>
        ))}
      </StyledTeamsGrid>
    </StyledTeamGroupingSection>
  );
};
